<template>
    <GmapAutocomplete @place_changed="setPlace" :options="{fields: ['geometry', 'formatted_address', 'place_id']}"
    >
        <template v-slot:input="slotProps">
            <v-text-field outlined
                          dense
                          flat
                          solo
                          :placeholder="pHolder"
                          :value="address"
                          ref="input"
                          v-on:listeners="slotProps.listeners"
                          v-on:attrs="slotProps.attrs"
                          class="btn-edu-select-height"
                          hide-details="auto"
            >
                <template slot="append">
                    <v-icon color="primary">mdi-magnify</v-icon>
                </template>
            </v-text-field>
        </template>
    </GmapAutocomplete>
</template>

<script>
    import { Autocomplete as GmapAutocomplete } from 'gmap-vue'

    export default {
        name: "GMAutoComplete",
        components: {
            GmapAutocomplete
        },
        props: ['address', 'pHolder'],
        data() {
            return {
                currentPlace: null,
            }
        },
        methods: {
            setPlace(place) {
                this.currentPlace = place;
                this.addMarker();
            },
            addMarker() {
                if (this.currentPlace && this.currentPlace.geometry) {
                    this.$emit('placeAdded', {
                        address: this.currentPlace.formatted_address,
                        google_place_id: this.currentPlace.place_id,
                        longitude: this.currentPlace.geometry.location.lng(),
                        latitude: this.currentPlace.geometry.location.lat()
                    });
                }
            }
        }
    };
</script>

<style>
    .vue-map-container {
        border-radius: 10px !important;
        overflow: hidden;
    }
</style>
